/**
 * Il timbro: da quale variante+cadenza viene il punteggio di queste righe.
 *
 * Sta in un file suo perche' l'invariante e' piu' sottile di quanto sembri, e
 * ora ha due consumatori: la lista dei collegati e la riga dell'avversario gia'
 * scelto nella Sfida diretta. Se la regola vivesse in due posti, prima o poi uno
 * dei due inventerebbe un timbro che il server non ha mai onorato — e un timbro
 * inventato fa passare un numero sbagliato attraverso la guardia di render.
 */

import { ratingBucketKey, type RatingBucket } from './rating-bucket';
import type { OnlineUser } from '../store/online-store';

/**
 * Timbra le righe col bucket che il SERVER ha onorato — e solo con quello.
 *
 * `bucketOnorato` assente non e' un dettaglio: significa che la risposta e'
 * arrivata dalla firma senza bucket (un server su un rilascio precedente, o il
 * ripiego di `getOnlineUsers` dopo un ack mancato), quindi i punteggi sono
 * quelli della cache di presenza — blitz internazionale — e non di cio' che chi
 * guarda ha davanti. In quel caso le righe escono NUDE: chi le legge sa che
 * senza timbro non si mostra nessun numero, ed e' esattamente il comportamento
 * voluto.
 */
export function timbraPunteggi(
  users: OnlineUser[],
  bucketOnorato: RatingBucket | undefined,
): OnlineUser[] {
  if (!bucketOnorato) return users;
  const timbro = ratingBucketKey(bucketOnorato);
  return users.map((u) => ({ ...u, ratingBucket: timbro }));
}
